<template>
  <auth>
    <div
      v-if="step==1"
      class="auth"
    >
      <h4>Recover your account.</h4>
      <hr>
      <form
        class="login"
        @submit.prevent="recover"
      >
        <div v-html="$error.handle(error)" />
        <div class="form-group">
          <label for="username">Email</label>
          <input
            id="username"
            v-model="user.email"
            type="text"
            class="form-control"
            required
          >
        </div>
        <div class="form-group">
          <button class="btn btn-primary">
            Send Recovery Email
          </button>
        </div>
      </form>
      <br>
      <router-link
        class="link"
        :to="{name: 'login'}"
      >
        Have an account? Log In
      </router-link>
    </div>
    <div v-if="step == 2">
      <div class="alert alert-info">
        <h4>Email Sent.</h4>
        <p>
          We have sent an email to {{ user.email }}. Click on the link on the email to
          recover your account.
        </p>
      </div>
    </div>
  </auth>
</template>

<script>
    import Auth from "@/components/Auth.vue";

    export default {
        components: {
            Auth
        },

        data() {
            return {
                user: {
                    email: '',
                },
                error: '',
                step: 1
            }
        },

        methods: {
            recover() {
                this.$axios.post('/api/password-reset-email', this.user).then(() => {
                    this.step = 2
                }).catch(error => {
                    this.error = error.response;
                });
            }
        }
    }
</script>
